import { ar, enUS, fr, id, tr } from 'date-fns/locale';

const DATE_FNS_LOCALES = {
  ar,
  en: enUS,
  fr,
  id,
  tr,
};

const INTL_LOCALES = {
  ar: 'ar',
  en: 'en-US',
  fr: 'fr-FR',
  id: 'id-ID',
  tr: 'tr-TR',
};

export function normalizeLanguage(language) {
  return String(language || 'en').split('-')[0].toLowerCase();
}

export function getDateFnsLocale(language) {
  const code = normalizeLanguage(language);
  return DATE_FNS_LOCALES[code] || enUS;
}

export function getIntlLocale(language) {
  const code = normalizeLanguage(language);
  return INTL_LOCALES[code] || 'en-US';
}
